/** Shared ABC Fitness Developer Platform landing page. */
export const PORTAL_LANDING_ROUTE = "/portal";

/** Canonical ABC Fitness Developer Portal entry (login). */
export const PORTAL_HOME_ROUTE = "/home";

/** Sign up under the ABC Fitness Developer Portal. */
export const PORTAL_SIGNUP_ROUTE = "/home/signup";

/** @deprecated Prefer {@link PORTAL_HOME_ROUTE}. Kept for legacy bookmarks. */
export const PORTAL_LOGIN_LEGACY_ROUTE = "/login";

/** @deprecated Prefer {@link PORTAL_SIGNUP_ROUTE}. Kept for legacy bookmarks. */
export const PORTAL_SIGNUP_LEGACY_ROUTE = "/signup";
